export const MOBILE_WIDTH = 600;
export const SPECIAL_INDEXIES = [1, 2, 5, 11, 14, 20, 33, 37, 56, 59, 70, 82, 93];